// extracted by mini-css-extract-plugin
export default {"mobileCardContainer":"RenderedPost_mobileCardContainer__WLTDA","desktopCardContainer":"RenderedPost_desktopCardContainer__qL1cz"};